/**
 * This is to register BootstrapVue dummy components. As those are in the code to make code portable with Aimera Manage and Admin environments
 */
import { defineComponent } from 'vue'

const EmptyComponent = defineComponent({
  render() {
    // Renders the default slot content seamlessly, ignoring named slots like #append
    return this.$slots.default ? this.$slots.default() : null
  }
})

// Register the missing BootstrapVue tags as empty wrappers
const missingComponents = ['b-form-radio-group', 'b-form-input', 'b-input-group', 'b-button']

export default function createBootstrapVuePlaceholders(app: any){
	missingComponents.forEach(tag => {
		app.component(tag, EmptyComponent)
	})
}